<template>
  <div class="row justify-center items-center tw-h-screen">
    <q-spinner-ball color="primary" size="7em" />
  </div>
</template>
<script setup lang="ts"></script>
<style lang=""></style>
